var BOG_LINE_GAME_TYPES = {
    ONLY_CRASH: 'ONLY_CRASH',
    ONLY_MARKET: 'ONLY_MARKET',
    MARKET_AND_CRASH: 'MARKET_AND_CRASH',
};
var UPDATED_BET_DATA_KEYS = {
    index: 'index',
    amount: 'amount',
    isBetAccepted: 'isBetAccepted',
};
var UpdatedSoundDataKeys = {
    isSoundOn: 'isSoundOn',
    isSoundOnPrev: 'isSoundOnPrev',
};
var bogLineMinOdd = 1.01;
var repliedGamePath = function () { return "/replay"; };
var checkGameIsReplied = function (pathName) { return pathName.includes("/replay"); };

export { BOG_LINE_GAME_TYPES, UPDATED_BET_DATA_KEYS, UpdatedSoundDataKeys, bogLineMinOdd, checkGameIsReplied, repliedGamePath };
